import Vue from "vue";
import { Component } from "vue-property-decorator";

import { ClientNotifier} from "../../scripts/ah.mb.client-notifications";
import { FetchWrapper } from "../../infrastructure/fetch-wrapper";
import { IUserAccount } from "../../infrastructure/userAccount";


@Component
export default class RegisterUserDialog extends Vue {


// Create user notifier
    private userNotifier = new ClientNotifier();

    //value: IUserAccount = {

    //    confirmPassword: "",
    //    email: "",
    //    firstName: "",
    //    isEnabled: true,
    //    lastName: "",
    //    password: "",
    //    roles: "",
    //    userName: ""
    //};

    mounted() {
     
    }


    value: IUserAccount = {

        confirmPassword: "",
        email: "",
        firstName: "",
        isApproved: true,
        lastName: "",
        password: "",
        roles: "User",
        userName: "",
        isConfirmed: true,
        userGroups: []
    };



    //saveUser() {
    //    {
    //        var notification = this.userNotifier.showNotification("Saving user...", true, true);

    //        // var form = $('form#createUserForm').serialize();

    //        const request = {
    //            method: "post",
    //            body: JSON.stringify(this.value),
    //        };

    //        FetchWrapper.sendCommandAndHandle("/accounts/edit", request)
    //            .then(data => {

    //                if (data.success)
    //                    this.value = {
    //                        confirmPassword: "",
    //                        email: "",
    //                        firstName: "",
    //                        isEnabled: true,
    //                        lastName: "",
    //                        password: "",
    //                        roles: "",
    //                        userName: ""
    //                    };

    //            }).then(() => {
    //                this.userNotifier.clear(notification);
    //                this.$emit("dialogClosed", "ok");

    //            });

    //    }
    //}


    registerUser(value: IUserAccount) {
        {
            var notification = this.userNotifier.showNotification("Registering user...", true, true);

           // var form = $('form#createUserForm').serialize();

            const request = {
                method: "post",
                body: JSON.stringify(value),
            };

            FetchWrapper.sendCommandAndHandle("/accounts/register", request)
                .then(data => {

                    // Don't need to show notification its in the toastr
                    //MessageBox.alert(
                    //    {
                    //        title: "Register user",
                    //        content: data.response
                    //    },
                    //    () => { });

                    if (data.success) 
                        this.$emit("dialogClosed", "ok");


                        //this.value = {
                        //    confirmPassword: "",
                        //    email: "",
                        //    firstName: "",
                        //    isEnabled: true,
                        //    lastName: "",
                        //    password: "",
                        //    roles: "",
                        //    userName: ""
                        //};

                }).then(() => {
                    this.userNotifier.clear(notification);
                });

        }
    }

    onCancelClick() {
        this.$emit("dialogClosed", "cancel");
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/accounts/register-user-dialog.ts